import { AncillaryFetchOfferRequest, AncillaryPostBookingPurchaseSuccess, CallState, CfarOffer } from "redmond";
import { IStoreState } from "../../../../reducers/types";
import { CfarPostBookingOfferKindEnum } from "..";

export const postBookingOfferStateSelector = (state: IStoreState) =>
  state.flightAncillary.postBookingOfferState;

export const cfarPostBookingOfferStateSelector = (state: IStoreState) =>
  state.flightAncillary.cfarPostBookingOfferState;

export const cfarPostBookingOfferSelector = (
  state: IStoreState,
): CfarOffer | undefined => {
  const offerState = state.flightAncillary.cfarPostBookingOfferState;
  if (offerState.state === CfarPostBookingOfferKindEnum.ValidOffer) {
    return offerState.cfarOffer;
  }
  return undefined;
};

export const cfarPostBookingFetchOfferRequestSelector = (
  state: IStoreState,
): AncillaryFetchOfferRequest | undefined => {
  const offerState = state.flightAncillary.cfarPostBookingOfferState;
  if (offerState.state === CfarPostBookingOfferKindEnum.ValidOffer) {
    return offerState.fetchOfferRequest;
  }
  return undefined;
};

export const cfarPostBookingPurchaseCallStateSelector = (
  state: IStoreState,
): CallState => state.flightAncillary.cfarPostBookingPurchaseCallState;

export const cfarPostBookingPurchaseResponseSelector = (
  state: IStoreState,
): AncillaryPostBookingPurchaseSuccess | null =>
  state.flightAncillary.cfarPostBookingPurchaseResponse;
